
import { Component, Input, OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../../components/sample/model/question-base';


@Component({
  selector: 'numerictextbox-question',
  template:`<div [formGroup]="form">
  <kendo-formfield>
      <!-- <kendo-label [for]="question.key" [text]="question.label"></kendo-label> -->
      <kendo-floatinglabel  [text]="question.label">
      <kendo-numerictextbox
      [id]="question.key"
      [formControlName]="question.key"
              [min]="0"
              
              [disabled]=" question.value && question.disabled"
            ></kendo-numerictextbox>
            </kendo-floatinglabel>
            <kendo-formhint *ngIf="question.hint" align="start">
           {{question.hint}}
          </kendo-formhint>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.required">Error: {{errorRequired.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.max">Error: {{errorMax.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.min">Error: {{errorMin.value}}</kendo-formerror>
          </kendo-formfield>
          <!-- {{ form.controls[question.key]| json }} -->
</div>`
})
export class NumerictextboxFormQuestionComponent implements OnChanges {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;

  errorRequired: { key: string; value: string; };
  errorMax: { key: string; value: string; };
  errorMin: { key: string; value: string; };

  ngOnChanges(changes: SimpleChanges) {
    // console.log('isEmptynumbers', this.question.value && this.question.disabled,this.question)
    if(changes.question.firstChange){ 
      console.log('changes.question.currentValue.errors',changes.question.currentValue)
      this.errorRequired = changes.question.currentValue.errors.find( ({ key }) => key === 'required' )
      this.errorMax = changes.question.currentValue.errors.find( ({ key }) => key === 'max' )
      this.errorMin = changes.question.currentValue.errors.find( ({ key }) => key === 'min' )
    }
  }
}